import React, { FunctionComponent } from 'react';
import { ID } from '../../../types/api/ID';
import { ContentListItem } from '../ContentList';
import { ContentListItemProps } from '../ContentList/parials/ContentListItem';
import { appendModifiers } from '../../../lib/bemUtils/Modifier';
import { useDraggableListItem } from '../../DragAndDrop';
import { ContentListItemModifier } from '../ContentList/parials/ContentListItem';

type DraggableProps = {
  modifier?: ContentListItemProps['modifier'];
};
export function asDraggableContentListItem<T extends ID>(Component: FunctionComponent<T>) {
  function Draggable({ modifier, ...props }: T & DraggableProps) {
    const typedProps = props as T;
    const { getListItemProps, isDragging } = useDraggableListItem(typedProps, Component);
    return (
      <ContentListItem
        id={props.id}
        {...getListItemProps()}
        modifier={appendModifiers(modifier, isDragging ? ContentListItemModifier.DRAGGING : undefined)}
      >
        <Component {...typedProps} />
      </ContentListItem>
    );
  }

  return Draggable;
}
